import { HobbyFishingMinigameConfig, InventorySnapshot } from '~/shared';

export const GREEN_ZONE_MAX_DIFF = 40;
export const ORANGE_ZONE_MAX_DIFF = 70;

export type WaitTimeRangeSec = { minSec: number; maxSec: number };

export function getWaitTimeRangeByDifference(
	difference: number,
	minigameConfig: HobbyFishingMinigameConfig,
): WaitTimeRangeSec {
	if (difference <= GREEN_ZONE_MAX_DIFF) {
		return {
			minSec: minigameConfig.waitGreenSecMin,
			maxSec: minigameConfig.waitGreenSecMax,
		};
	}
	if (difference <= ORANGE_ZONE_MAX_DIFF) {
		return {
			minSec: minigameConfig.waitOrangeSecMin,
			maxSec: minigameConfig.waitOrangeSecMax,
		};
	}
	return {
		minSec: minigameConfig.waitOtherSecMin,
		maxSec: minigameConfig.waitOtherSecMax,
	};
}

export function hasFreeInventorySlot(
	inventory: InventorySnapshot | null,
): boolean {
	if (!inventory || inventory.isInfinite) {
		return true;
	}

	const filledCount = inventory.items.filter((stack) => stack !== null).length;
	return filledCount < inventory.capacity;
}

export enum FishingStages {
	NotStarted = 'notStarted',
	Waiting = 'waiting',
	CatchFishTypeA = 'catchFishTypeA',
	CatchFish = 'catchFish',
	CatchFishTypeB = 'catchFishTypeB',
}

export const waitingTexts = [
	'Мне этот мир абсолютно понятен...',
	'Ловись рыбка...',
	'Удочку надо обновить',
	'Щас бы Ниву новую... эх...',
	'Может машину купить?',
	'Может одежду купить?',
	'Пу-пу-пу...',
	'Але, рыба! Иди сюда, разговор есть!',
	'А акулы тут водятся?',
	'Вырасту, стану депутатом!',
	'А что если это симуляция?',
	'На кондициях сегодня!',
	'Подомной М5, асфальт 8...',
	'Щас бы в хогвардс...',
	'Поплавать что ли...',
	'ЯЯЯЗЗЪ, ЗДОРОВЕННЫЙ!!!',
	'Щас бы в GTA 6 поиграть',
	'Интересно, а что там в космосе?',
	'Тут вообще рыба есть?',
	'Вот язя бы поймать!',
	'Айоу, акак, вот вам два...',
	'Ветер с моря дул, ветер с моря дул...',
	'Сидим с бобром за столом...',
	'Есть ли золотая рыбка?',
];

export const fishingProgressTexts = {
	lowProgress: ['Она ускользает...'],
	highProgress: ['Ещё чуть-чуть!!!'],
	normalProgress: ['У вас клюет!'],
};
